var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('span',{staticClass:"col"},[_c('b',[_vm._v(_vm._s(this.kkey))])]),_vm._v(" "),_c('span',{staticClass:"col"},[_vm._v(_vm._s(this.vvalue))])])}
var staticRenderFns = []

export { render, staticRenderFns }